// @flow

module.exports = {
	init: function() {
		var allLazyImages: HTMLImageElement[] = ((document.querySelectorAll(
			"img[data-src]"
		): any): HTMLImageElement[]);
		if (window.IntersectionObserver) {
			setupObserver(Array.prototype.slice.call(allLazyImages));
		} else {
			allLazyImages.forEach(i => (i.src = i.dataset.src));
		}
	}
};

function setupObserver(imgs: HTMLImageElement[]) {
	const observer = new IntersectionObserver(handler, {});
	imgs.forEach(img => {
		observer.observe(img);
	});
	function handler(entries: IntersectionObserverEntry[]) {
		const eles: HTMLImageElement[] = [];
		entries.forEach((entry, obserer) => {
			if (entry.intersectionRatio > 0) {
				const target: HTMLImageElement = ((entry.target: any): HTMLImageElement);
				target.src = target.dataset.src;
				eles.push(target);
			}
		});
		eles.forEach(t => {
			observer.unobserve(t);
		});
	}
}
